<template>
    <div>
        <detailsUser :data="data" v-on:clickNextPageUpdate="clickNextPageUpdate($event)" v-if="edit_item"></detailsUser>
        <updateUser :data="data" v-on:clickNextPageDetailsBtnUpdate="clickNextPageDetailsBtnUpdate($event)" v-on:clickNextPageDetailsBtnCancel="clickNextPageDetailsBtnCancel($event)" v-on:clickTypeGender="clickTypeGender($event)" v-else></updateUser>
    </div>
</template>
<script>
import detailsUser from "@/components/personSet/infoUser/detailsInfo/details";
import updateUser from "@/components/personSet/infoUser/detailsInfo/updateInfo";
export default {
    props: {
      data: {
        type:Object,
        default: {}
      },
    },
    components: {
      detailsUser,
      updateUser
    },
    data() {
        return {
            edit_item: 1,
        };
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        
    },
    methods: {
        clickNextPageUpdate(params){
            this.$emit("changeItem", "1");
            this.$emit("getInfoCurrent", true);
            this.edit_item = params;
        },
        clickNextPageDetailsBtnUpdate(params){
            this.$emit("changeItem", "0");
            this.$emit("updateInfoUser", true);
            this.edit_item = params;
        },
        clickNextPageDetailsBtnCancel(params){
            this.$emit("changeItem", "0");
            this.$emit("updateInfoUser", false);
            this.edit_item = params;
        },
        clickTypeGender(params){
            this.$emit("checkGenderUser", params);
        }
    },
    };
</script>
<style scoped>
    .btn-infouser button{
        float: right;
        margin-top: 15px;
        padding: 10px;
        border-radius: 5px;
        border: 0;
        background: #0071c5;
        color: #fff;
        margin-left: 10px;
    }
    .btn-infouser button:hover {
        background: #007aff!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/personSet/infoUser/userDetails.vue